import React from 'react';
import { motion } from 'framer-motion';
import { Navigation, User, Clock, MapPin, Zap } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
const activeJobs = [{
  id: 'JOB-101',
  rider: 'John Doe',
  customer: 'Alice Smith',
  status: 'in_progress',
  eta: '5 min',
  pickup: 'Downtown',
  dropoff: 'Airport'
}, {
  id: 'JOB-102',
  rider: 'Mike Ross',
  customer: 'Bob Johnson',
  status: 'pending',
  eta: '2 min',
  pickup: 'Mall',
  dropoff: 'Suburbs'
}, {
  id: 'JOB-103',
  rider: 'Searching...',
  customer: 'Charlie Brown',
  status: 'pending',
  eta: '--',
  pickup: 'Station',
  dropoff: 'Hotel'
}, {
  id: 'JOB-104',
  rider: 'Clark Kent',
  customer: 'Eve Davis',
  status: 'in_progress',
  eta: '12 min',
  pickup: 'Office Park',
  dropoff: 'Residential'
}, {
  id: 'JOB-105',
  rider: 'Diana Prince',
  customer: 'Frank Miller',
  status: 'in_progress',
  eta: '8 min',
  pickup: 'University',
  dropoff: 'Hospital'
}];
export function DispatchOverview() {
  return <div className="h-[calc(100vh-8rem)] flex flex-col lg:flex-row gap-6" data-id="element-416">
      {/* Map Area */}
      <div className="flex-1 bg-famo-navy/5 rounded-xl border border-slate-200 relative overflow-hidden" data-id="element-417">
        {/* Proximity Assignment Info Banner */}
        <div className="absolute top-4 left-1/2 -translate-x-1/2 z-10 bg-famo-gold/90 backdrop-blur-sm text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 text-sm font-medium" data-id="element-418">
          <Zap size={16} className="animate-pulse" data-id="element-419" />
          <span data-id="element-420">
            Auto-Assignment: Riders matched by proximity to pickup location
          </span>
        </div>

        {/* Grid pattern background */}
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'radial-gradient(circle, #0C1222 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-421" />

        {/* Mock city grid */}
        <svg className="absolute inset-0 w-full h-full opacity-20" viewBox="0 0 800 600" data-id="element-422">
          <line x1="100" y1="0" x2="100" y2="600" stroke="#0C1222" strokeWidth="1" data-id="element-423" />
          <line x1="250" y1="0" x2="250" y2="600" stroke="#0C1222" strokeWidth="1" data-id="element-424" />
          <line x1="400" y1="0" x2="400" y2="600" stroke="#0C1222" strokeWidth="2" data-id="element-425" />
          <line x1="550" y1="0" x2="550" y2="600" stroke="#0C1222" strokeWidth="1" data-id="element-426" />
          <line x1="700" y1="0" x2="700" y2="600" stroke="#0C1222" strokeWidth="1" data-id="element-427" />
          <line x1="0" y1="100" x2="800" y2="100" stroke="#0C1222" strokeWidth="1" data-id="element-428" />
          <line x1="0" y1="250" x2="800" y2="250" stroke="#0C1222" strokeWidth="1" data-id="element-429" />
          <line x1="0" y1="400" x2="800" y2="400" stroke="#0C1222" strokeWidth="2" data-id="element-430" />
          <line x1="0" y1="550" x2="800" y2="550" stroke="#0C1222" strokeWidth="1" data-id="element-431" />
        </svg>

        {/* Rider markers */}
        <div className="absolute top-[25%] left-[30%]" data-id="element-432">
          <div className="relative" data-id="element-433">
            <div className="w-4 h-4 bg-famo-gold rounded-full border-2 border-white shadow-lg animate-pulse" data-id="element-434" />
            <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-famo-navy text-white px-2 py-1 rounded shadow text-xs font-bold whitespace-nowrap" data-id="element-435">
              JOB-101
            </div>
          </div>
        </div>
        <div className="absolute top-[55%] left-[60%]" data-id="element-436">
          <div className="relative" data-id="element-437">
            <div className="w-4 h-4 bg-famo-gold rounded-full border-2 border-white shadow-lg animate-pulse" data-id="element-438" />
            <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-famo-navy text-white px-2 py-1 rounded shadow text-xs font-bold whitespace-nowrap" data-id="element-439">
              JOB-104
            </div>
          </div>
        </div>
        <div className="absolute top-[40%] left-[45%]" data-id="element-440">
          <div className="relative" data-id="element-441">
            <div className="w-4 h-4 bg-famo-gold rounded-full border-2 border-white shadow-lg animate-pulse" data-id="element-442" />
            <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-famo-navy text-white px-2 py-1 rounded shadow text-xs font-bold whitespace-nowrap" data-id="element-443">
              JOB-105
            </div>
          </div>
        </div>

        {/* Pending markers */}
        <div className="absolute top-[70%] left-[20%]" data-id="element-444">
          <div className="relative" data-id="element-445">
            <div className="w-3 h-3 bg-yellow-400 rounded-full border-2 border-white shadow-lg" data-id="element-446" />
            <div className="absolute -top-7 left-1/2 -translate-x-1/2 bg-white text-slate-600 px-2 py-0.5 rounded shadow text-[10px] font-medium whitespace-nowrap" data-id="element-447">
              Awaiting rider
            </div>
          </div>
        </div>

        <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-lg shadow-sm border border-slate-200 text-xs text-slate-600 flex items-center gap-3" data-id="element-448">
          <span className="flex items-center gap-1" data-id="element-449">
            <span className="w-2 h-2 rounded-full bg-famo-gold animate-pulse" data-id="element-450" />{' '}
            Active
          </span>
          <span className="flex items-center gap-1" data-id="element-451">
            <span className="w-2 h-2 rounded-full bg-yellow-400" data-id="element-452" /> Pending
          </span>
        </div>
        <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm p-2 rounded-lg shadow-sm text-xs text-slate-500" data-id="element-453">
          Live Dispatch Map
        </div>
      </div>

      {/* Job List */}
      <div className="w-full lg:w-96 bg-white rounded-xl shadow-sm border border-slate-100 flex flex-col overflow-hidden" data-id="element-454">
        <div className="p-4 border-b border-slate-100 flex justify-between items-center flex-shrink-0" data-id="element-455">
          <h3 className="font-bold text-slate-800" data-id="element-456">Active Dispatch</h3>
          <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-xs font-bold" data-id="element-457">
            {activeJobs.length} Live
          </span>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-4" data-id="element-458">
          {activeJobs.map((job, idx) => <motion.div key={job.id} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: idx * 0.1
        }} className="border border-slate-200 rounded-lg p-4 hover:border-famo-gold transition-colors cursor-pointer" data-id="element-459">
              <div className="flex justify-between items-start mb-3" data-id="element-460">
                <span className="font-mono text-xs text-slate-500" data-id="element-461">
                  {job.id}
                </span>
                <StatusBadge status={job.status} data-id="element-462" />
              </div>
              <div className="space-y-2 mb-3" data-id="element-463">
                <div className="flex items-center gap-2 text-sm" data-id="element-464">
                  <Navigation size={14} className="text-famo-navy" data-id="element-465" />
                  <span className="font-medium text-slate-800" data-id="element-466">
                    {job.rider}
                  </span>
                </div>
                <div className="flex items-center gap-2 text-sm" data-id="element-467">
                  <User size={14} className="text-slate-400" data-id="element-468" />
                  <span className="text-slate-600" data-id="element-469">{job.customer}</span>
                </div>
              </div>
              {job.status === 'pending' && job.rider === 'Searching...' && <div className="mb-3 p-2 bg-yellow-50 border border-yellow-200 rounded text-xs text-yellow-700 flex items-center gap-2" data-id="element-470">
                  <MapPin size={12} data-id="element-471" />
                  <span data-id="element-472">Finding nearest available rider...</span>
                </div>}
              <div className="flex items-center gap-2 text-xs text-slate-500 border-t border-slate-100 pt-3" data-id="element-473">
                <Clock size={12} data-id="element-474" />
                <span data-id="element-475">
                  ETA:{' '}
                  <span className="font-bold text-slate-700" data-id="element-476">{job.eta}</span>
                </span>
                <span className="mx-1" data-id="element-477">•</span>
                <span data-id="element-478">
                  {job.pickup} → {job.dropoff}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}